<template>
  <div style="height: 100%" class="bgk">
    <div class="xqleft2">
      <div style="display: flex; " class="biaoti">

        <h1 style="color: #fff; font-size: 14px; ">
          高电压单体排行
        </h1>
      </div>
      <v-chart class="chart" :option="options" :autoresize="true" />
    </div>
    <div class="xqleft2">
      <div style="display: flex; " class="biaoti">

        <h1 style="color: #fff; font-size: 14px; ">
          低电压单体排行
        </h1>
      </div>
      <v-chart class="chart" :option="options" :autoresize="true" />
    </div>
    <div class="xqleft">
      <div style="display: flex; " class="biaoti">

        <h1 style="color: #fff; font-size: 14px; ">故障统计</h1>
      </div>
      <div>
        <GaoJing :chatdata="chatdata" />
      </div>
      <div class="llist">
        <ul>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ info.warning_num_total }}<span class="danwei">次</span></h2>
            <h1 class="mingcheng">告警次数</h1>

          </li>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ info.warning_process_percent }}<span class="danwei">%</span></h2>
            <h1 class="mingcheng">处理情况</h1>

          </li>
          <li style="width: 33%">
            <h2 class="shuzhi">{{ info.process_avg_time }}<span class="danwei">分钟</span></h2>
            <h1 class="mingcheng">平均处理时间</h1>

          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import http from "@/api/http";
import { useStore } from "vuex";

import { defineComponent, ref, onMounted } from "vue";
//import * as echarts from 'echarts';
import GaoJing from "./GaoJing.vue";
import "echarts-liquidfill";
export default defineComponent({
  components: {

    GaoJing,
  },
  setup() {
    var data = [70, 49, 50];
    var className = ["单体1", "单体2", "单体3"];
    var colorList = ["#00ffff", "#2489ff", "#9747ff", "#54D9FF", "#987EFF"];
    var defaultData = [100, 100, 100, 100, 100, 100];

    const options = ref({
      grid: {
        left: "5%",
        right: "5%",
        bottom: "0%",
        top: "3%",
        containLabel: true,
      },
      tooltip: {
        trigger: "axis",
        axisPointer: {
          type: "none",
        },
        formatter: function (params) {
          return (
            params[0].name +
            "<br/>" +
            // "<span style='display:inline-block;margin-right:5px;border-radius:10px;width:9px;height:9px;background-color:rgba(36,207,233,0.9)'></span>" +
            // params[0].seriesName + ' : ' + Number((params[0].value.toFixed(4) / 10000).toFixed(2)).toLocaleString() + ' <br/>'
            params[0].seriesName +
            " : " +
            params[0].value +
            "%"
          );
        },
      },

      xAxis: {
        show: false,
        type: "value",
      },
      yAxis: [
        {
          type: "category",
          inverse: true,
          axisLabel: {
            show: true,
            textStyle: {
              color: "#fff",
            },
          },
          splitLine: {
            show: false,
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
          data: className,
        },
        {
          type: "category",
          inverse: true,
          axisTick: "none",
          axisLine: "none",
          show: true,
          axisLabel: {
            textStyle: {
              color: "#ffffff",
              fontSize: "12",
            },
            formatter: function (value) {
              return value + " V";
            },
          },
          data: data,
        },
      ],
      series: [
        {
          name: "占比",
          type: "bar",
          zlevel: 1,
          itemStyle: {
            normal: {
              barBorderRadius: 30,
              // color: new echarts.graphic.LinearGradient(0, 0, 1, 0, [{
              //     offset: 0,
              //     color: 'rgb(57,89,255,1)'
              // }, {
              //     offset: 1,
              //     color: 'rgb(46,200,207,1)'
              // }]),
              color: (params) => {
                return colorList[params.dataIndex];
              },
            },
          },
          barWidth: 10,
          data: data,
        },
        {
          name: "背景",
          type: "bar",
          barWidth: 10,
          barGap: "-100%",
          data: defaultData,
          itemStyle: {
            normal: {
              color: "#2C3767",
              barBorderRadius: 30,
            },
          },
        },
      ],
    });
    let chatdata = ref({})
    let info = ref({})
    const store = useStore()
    let stationid = store.getters['User/stationid']
    const getData = () => {
      http.get("/base_station_warning/" + stationid + "/statistics").then((res) => {

        chatdata.value = res.data.warning_list
        info.value = res.data

      });
      // http.get("/base_station/" + stationid + "/power").then((res) => {

      //   info.value = res.data

      // });
    };

    onMounted(() => {
      //组件挂载时的生命周期执行的方法
      getData()
    });

    return {
      options, chatdata, info
    };
  },
});
</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bgk {
  background: url("@/assets/bjk2.png");
  background-size: 100% 100%;
  padding-top: 50px;
  font-weight: bold;
}

.biaoti {
  background: url("@/assets/biaoti.png") no-repeat;
  margin: 0 20px;
  padding-left: 28px;
}

.xqleft {

  height: 52%;

  color: #fff;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.xqleft2 {

  height: 24%;

  color: #fff;
  display: flex;
  flex-direction: column;
  margin-bottom: 20px;
}

.quxian {
  font-size: 18px;
  color: #fdff76;
}

.llist {
  padding: 10px 20px 0;
  overflow: hidden;
}

.llist ul li {
  float: left;
  list-style: none;
  width: 50%;
  color: #fff;
  margin-bottom: 20px;
  text-align: center;
}

.mingcheng {
  color: #ccccdc;
  font-size: 13px;
  padding: 0;
  margin: 0;
}

.shuzhi {
  color: #2489ff;
  font-size: 18px;
  padding: 0;
  margin: 0;
  font-family: Arial, Helvetica, sans-serif;
  font-weight: bold;
}

.danwei {
  color: #fff;
  font-size: 12px;
  padding-left: 5px;
}
</style>
